const DATAGRAIL_CUSTOMER_ID =
  process.env["NEXT_PUBLIC_DATAGRAIL_CUSTOMER_ID"] ?? "";

const DATAGRAIL_CONTAINER_ID =
  process.env["NEXT_PUBLIC_DATAGRAIL_CONTAINER_ID"] ?? "";

export const DATAGRAIL_LOADER_URL =
  DATAGRAIL_CUSTOMER_ID && DATAGRAIL_CONTAINER_ID
    ? `https://api.consentjs.datagrail.io/${DATAGRAIL_CUSTOMER_ID}/${DATAGRAIL_CONTAINER_ID}/consent-loader.js`
    : "";

export const DATAGRAIL_PERFORMANCE_CATEGORY = "performance";
